module.exports = __webpack_public_path__ + "static/img/2.5a1129b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/2.png
// module id = NIus
// module chunks = 1